

type Size = "xs" | "md" | "xl" | "2xl" | "3xl" | "4xl" | "5xl" | "6xl" | "lg"


export const spacing = (size: Size) => {
    return `var(--spacing-${size}-n)`
}